import React from 'react';
import { orderDetailsMarkup, Styled, TrackingInformationProps } from './';
import Image from "next/legacy/image";
import { useI18n } from 'contexts/i18n';


const TrackingInformation = ({ order }: TrackingInformationProps) => {
const i18n = useI18n();
  return (
    (<Styled.ColumnBody>
      <Styled.ColumnBody>
        <Styled.HeadParent>
          <Styled.HeadBody>{i18n['Tracking Information']}</Styled.HeadBody>
        </Styled.HeadParent>
        {order.orderTracking.map(order => (
          <Styled.DescriptionRow key={order.trackingNumber} block>
            <Styled.TrackingID>
              <Styled.BoxIcon>📦</Styled.BoxIcon>{' '}
              {order.trackingUrl ? i18n['Tracking ID:'] : i18n['Tracking Status: ']}{' '}
              {order.trackingUrl ? (
                // eslint-disable-next-line react/jsx-no-target-blank
                (<a href={order.trackingUrl} target="_blank">
                  {order.trackingNumber}
                </a>)
              ) : null}
              <Styled.TrackingState orderStatus={order.trackingState}>
              {i18n[order.trackingState] || order.trackingState}
              </Styled.TrackingState>
            </Styled.TrackingID>
            <Styled.TrackingInfoHeader>
              <div></div>
              <div>{orderDetailsMarkup(i18n).productName}</div>

              <div>{orderDetailsMarkup(i18n).quantity}</div>
            </Styled.TrackingInfoHeader>
            {order.lineItems.map(lineItem => (
              <Styled.TrackingInfoRow key={lineItem.id}>
                <div>
                  <Image src={lineItem.imageUrl} width={40} height={40} />
                </div>
                <div>{lineItem.name}</div>
                <div>{lineItem.quantity}</div>
              </Styled.TrackingInfoRow>
            ))}
          </Styled.DescriptionRow>
        ))}
      </Styled.ColumnBody>
    </Styled.ColumnBody>)
  );
};

export default TrackingInformation;
